import React from "react";
import {useTranslation} from "react-i18next";
import styles from "./UIMessageControl.module.scss";
import {messageTypes, sendStatus} from "./ChatConstants";
import {Button} from "antd";

function UIMessageControl({
  userId,
  msgObj,
  refControl,
  handleSelectMessage,
  handleUnsendMseeage,
  handleReplyMessage,
  handleCopyMseeage,
}: any) {
  const { t } = useTranslation();
  const isAnother: number = userId === msgObj.userId ? 2 : 1;
  return (
    <div className={styles.boxActionControl} ref={refControl}>
      <div style={{ verticalAlign: "middle", alignItems: "center" }}>
        {msgObj?.messageType === messageTypes.Sticker ||
          msgObj?.messageType === messageTypes.Audio ||
          msgObj?.messageType === messageTypes.Sound ||
          msgObj?.messageType === messageTypes.MeetingRecord ? (
            <>
              <div className={styles.boxBorder}>
                <Button
                  type="link"
                  block
                  className={styles.boxBorder}
                  onClick={() => {
                    handleSelectMessage(sendStatus.Delete, msgObj?.messageId);
                  }}
                >
                  {t("Delete")}
                </Button>
              </div>
              {isAnother > 1 && (
                <div className={styles.boxBorder}>
                  <Button
                    type="link"
                    block
                    className={styles.boxBorder}
                    onClick={() => {
                      handleUnsendMseeage(
                        msgObj?.messageId,
                        msgObj?.groupId,
                        msgObj?.messageType,
                        msgObj?.messageDetails
                      )
                    }}
                  >
                    {t("Unsend")}
                  </Button>
                </div>
              )}
            </>
          ) : (
            <>
              {/* {msgObj?.messageType !== messageTypes.Image &&
                msgObj?.messageType !== messageTypes.CenterFlie &&
                msgObj?.messageType !== messageTypes.Video && */}
                {
                  (
                  <div className={styles.boxBorder} >
                    <Button
                      type="link"
                      block
                      className={styles.boxBorder}
                      onClick={() => {
                        handleReplyMessage(msgObj);
                      }}
                    >
                      {t("Reply")}
                    </Button>
                  </div>
                )}
              <div className={styles.boxBorder}>
                <Button
                  type="link"
                  block
                  className={styles.boxBorder}
                  onClick={() => {
                    handleCopyMseeage(msgObj?.messageText);
                  }}
                >
                  {t("Copy")}
                </Button>
              </div>
              <div className={styles.boxBorder}>
                <Button
                  type="link"
                  block
                  className={styles.boxBorder}
                  onClick={() => {
                    handleSelectMessage(sendStatus.Forward, msgObj?.messageId);
                  }}
                >
                  {t("Forward")}
                </Button>
              </div>
              <div className={styles.boxBorder}>
                <Button
                  type="link"
                  block
                  className={styles.boxBorder}
                  onClick={() => {
                    handleSelectMessage(sendStatus.Delete, msgObj?.messageId);
                  }}
                >
                  {t("Delete")}
                </Button>
              </div>
              {isAnother > 1 && (
                <div className={styles.boxBorder}>
                  <Button
                    type="link"
                    block
                    className={styles.boxBorder}
                    onClick={() => {
                      handleUnsendMseeage(
                        msgObj?.messageId,
                        msgObj?.groupId,
                        msgObj?.messageType,
                        msgObj?.messageDetails
                      )
                    }}
                  >
                    {t("Unsend")}
                  </Button>
                </div>
              )}
            </>
          )}
      </div>
    </div>
  );
}

export default React.memo(UIMessageControl);
